<template>
  <fts-dropdown-select
    append-to-body
    class="fts-standard-menu"
    content-class="standard-menu-dropdown"
    @selected="executeActivity"
    v-if="isStandardAction">
    <!-- toggle -->
    <template #toggle>
      <slot name="toggle">
        <font-awesome-icon
          :icon="['fas', 'ellipsis-v']"
          fixed-width
          class="standard-menu-toggle"
        />
      </slot>
    </template>
    <!-- menu -->
    <template #menu="{ select, defaultOptionClass }">
      <!-- view -->
      <a
        class="standard-activity"
        :class="defaultOptionClass"
        :href="getStandardAction('quickView') ? locusUrl : locusUrl + '&m=f'"
        target="_blank"
        @click="select"
        v-if="getStandardAction('quickView') || getStandardAction('view')"
      >
        <i class="standard-activity-icon" :class="icon('view')"></i>View in New Window
      </a>
      <!-- edit -->
      <div
        class="standard-activity"
        :class="defaultOptionClass"
        @click="select({ id: 'edit' })"
        v-if="getStandardAction('edit')"
      >
        <i class="standard-activity-icon" :class="icon('edit')"></i>Edit
      </div>
      <!-- delete -->
      <div
        class="standard-activity"
        :class="defaultOptionClass"
        @click="select({ id: 'delete' })"
        v-if="getStandardAction('delete')"
      >
        <i class="standard-activity-icon" :class="icon('delete')"></i>Delete
      </div>
      <!-- change state -->
      <div
        class="standard-activity"
        :class="defaultOptionClass"
        @click="select({ id: 'changeStatus' })"
        v-if="getStandardAction('changeStatus')"
      >
        <i class="standard-activity-icon" :class="icon('changeStatus')"></i>Change State
      </div>
      <!-- duplicate -->
      <div
        class="standard-activity"
        :class="defaultOptionClass"
        @click="select({ id: 'duplicate' })"
        v-if="getStandardAction('duplicate')"
      >
        <i class="standard-activity-icon" :class="icon('duplicate')"></i>Duplicate
      </div>
      <!-- admin features -->
      <fts-tippy
        v-for="adminFeature in getAdminFeatures"
        :key="adminFeature.id"
        append-trigger-class="dropdown-option dropdown-option--secondary"
        :content="adminFeature.tooltip"
        @trigger:click="select({ id: adminFeature.id })"
      >
        <template>
          <div class="dropdown-option-icon">
            <i :class="adminFeature.icon"></i>
          </div>
          <div>{{adminFeature.name}}</div>
        </template>
      </fts-tippy>
    </template>
  </fts-dropdown-select>
</template>

<script>
import commons from '../commons/commons';
import { authorizationStore } from '../store/authorizationStore';

import FTSDropdownSelect from './FTSDropdownSelect';
import FTSTippy from './FTSTippy';

export default {
  components: {
    "fts-dropdown-select": FTSDropdownSelect,
    "fts-tippy": FTSTippy
  },
  props: {
    standardActions: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    isLite: {
      type: Boolean,
      default: () => false,
    },
    moduleId: [String, Number],
    listId: String,
    /* SS06274: the module only reads its source (an AutoCount book). The listing header says so
       (readOnlySource), and Manage, which this menu adds for an admin by itself, is left out:
       the server offers no write on such a module to anyone. */
    readOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    icon(id) {
      try {
        return commons.standardActivities.find((x) => x.id === id).icon;
      } catch (err) {
        return "fts-icon-file";
      }
    },
    getStandardAction(item) {
      return this.standardActions.some((x) => x === item);
    },
    executeActivity(item) {
      if (item && item.id)
        this.$emit("executed", item);
    },
  },
  computed: {
    getAdminFeatures() {
      if (this.readOnly) return [];
      if (authorizationStore.getters.isAdminUser) {
        const availableAdminFeatures = ["manage"];
        return commons.adminFeatures.filter(x => availableAdminFeatures.includes(x.id));
      }
      return [];
    },
    isStandardAction() {
      if (this.getAdminFeatures.length)
        return true;

      const availableStandardActions = ["view", "edit", "delete", "changeStatus", "duplicate", "manage"];
      return this.standardActions.some(x => availableStandardActions.includes(x));
    },
    locusUrl() {
      return commons.clientPathUrl({
        moduleId: this.moduleId,
        listId: this.listId,
        id: this.item.id,
        isLite: this.isLite
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.fts-standard-menu {
  .standard-menu-toggle {
    font-size: 0.75rem;
    color: var(--fts-default);
  }
}
.standard-menu-dropdown {
  .standard-activity {
    font-size: var(--inistate-label-text-14);
    line-height: var(--inistate-paragraph-text-14--line-height);
    .standard-activity-icon {
      margin-right: 0.375rem;
      color: var(--fts-default);
    }
  }
}
</style>